import {createStore, applyMiddleware, compose} from 'redux';
import thunk from 'redux-thunk';
import {hashHistory} from 'react-router';
import {routerMiddleware} from 'react-router-redux';
import backend from '../middleware/backend'
import rootReducer from '../reducers';


const router = routerMiddleware(hashHistory);

const enhancer = compose(
	applyMiddleware(thunk, backend),
	applyMiddleware(thunk, router)
)

export default function configureStore(initialState) {
	return createStore(rootReducer, initialState, enhancer); // eslint-disable-line
}



// WEBPACK FOOTER //
// ./P:/Work/htdocs/biatlon/online/src/store/configureStore.production.js